import type { FC } from "react";
import { useSelector } from "react-redux";
import { getDeviceType } from "../../store/hideNavigation/hideNavigation";
import {
  Body,
  Checkbox,
  css,
  Flex,
  Link as ExternalLink,
  Margin,
  styled,
} from "@kivra/react-components";
import { useCopy } from "../../utils/globalContext";
import { getTerms, setTermsAccepted } from "../../store/auth";
import { useAppDispatch } from "../../store/configureStore";
import { KivraHeaderRouter } from "../header/KivraHeaderRouter";
import { ErrorMessage } from "../errors/ErrorMessage";
import { FadeInAndOut } from "../atoms/FadeInAndOut";

export const AcceptTerms: FC = () => {
  const copy = useCopy();
  const { termsAccepted } = useSelector(getTerms);
  const dispatch = useAppDispatch();
  const changeTerms = () => {
    dispatch(setTermsAccepted(!termsAccepted));
  };

  const termsConditionsArray = copy("signup__terms_conditions", {
    terms_link: "SPLIT_ME",
    privacy_link: "SPLIT_ME",
  }).split("\n\n");

  const tncLinkArray = termsConditionsArray[1]?.split("SPLIT_ME");

  const urlParams = () => {
    const deviceType = getDeviceType();
    if (deviceType === "android") {
      return "?device=" + deviceType;
    } else {
      return "";
    }
  };
  if (!tncLinkArray) return;
  const Terms = (
    <>
      <CenteredBody size="medium">{termsConditionsArray[0]}</CenteredBody>
      <CenteredBody size="medium">
        {tncLinkArray[0]}
        <Link
          to={copy("signup__terms_conditions__terms_link") +
            urlParams()}
          target="_blank"
        >
          {copy("signup__terms_conditions__terms_text")}
        </Link>
        {tncLinkArray[1]}
        <Link
          to={copy("signup__terms_conditions__privacy_link") +
            urlParams()}
          target="_blank"
        >
          {copy("signup__terms_conditions__privacy_text")}
        </Link>
        {tncLinkArray[2]}
      </CenteredBody>
      <CenteredBody size="medium">{termsConditionsArray[2]}</CenteredBody>
    </>
  );

  const Check1 = (
    <Margin top={18}>
      <Flex className={css({ marginRight: "$spacing-20" })}>
        <Checkbox
          label={copy("panel_signup_terms_conditions__user_accepts")}
          checked={termsAccepted}
          onChange={changeTerms}
        />
      </Flex>
    </Margin>
  );

  return (
    <div style={{ minWidth: "250px" }}>
      <KivraHeaderRouter />
      <ErrorMessage />
      <FadeInAndOut>
        <Margin bottom={16} />
        {Terms}
        <Margin bottom={32} />
        {Check1}
      </FadeInAndOut>
    </div>
  );
};

const CenteredBody = styled(Body)({
  textAlign: "center",
  margin: [0, 0, "$spacing-20", 0],
});

const Link = styled(ExternalLink)({
  "& span": {
    verticalAlign: "baseline",
  },
});
